/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedFinancialBorderoList } from '../models/PaginatedFinancialBorderoList';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FinancialBorderoService {

  /**
   * List bordero rows
   * Rows of the financial-risks bordero — the reporting register of contracts concluded, modified and resolved in a period. Same filters as the spreadsheet export (`agent_type`, `agent_id`, `start_date`, `end_date`, `contract_type`), so a screen can preview what `xlsx` will contain.
 *
 * The modified and resolved slices of this product are always empty — it has neither flow (see the class docstring).
   * @param agentId 
   * @param agentType * `employee` - employee
 * * `broker` - broker
 * * `website` - Website
 * * `mobile` - Mobile (iOS + Android)
   * @param contractType * `order` - Order
 * * `modification` - Modification
 * * `cancel` - Cancel
   * @param endDate 
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @param search Search fields: number, order__contractor__as_person__first_name, order__contractor__as_person__last_name, order__contractor__as_legalentity__name, order__contractor__as_legalentity__identification_number, order__contractor__as_person__identification_number
   * @param startDate 
   * @returns PaginatedFinancialBorderoList 
   * @throws ApiError
   */
  public static financialBorderoList(
agentId?: number,
agentType?: 'broker' | 'employee' | 'mobile' | 'website',
contractType?: 'cancel' | 'modification' | 'order',
endDate?: string,
page?: number,
pageSize?: number,
search?: string,
startDate?: string,
): CancelablePromise<PaginatedFinancialBorderoList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/financial/bordero/',
      query: {
        'agent_id': agentId,
        'agent_type': agentType,
        'contract_type': contractType,
        'end_date': endDate,
        'page': page,
        'page_size': pageSize,
        'search': search,
        'start_date': startDate,
      },
    });
  }

  /**
   * Download the bordero spreadsheet
   * Renders `templates/docs/financial/borderoul-financial.xlsx` from the filtered selection: three sections (concluded / modified / resolved) plus the summary table. Refuses a selection over 30 000 rows rather than filling the worker with cells.
   * @param agentId 
   * @param agentType * `employee` - employee
 * * `broker` - broker
 * * `website` - Website
 * * `mobile` - Mobile (iOS + Android)
   * @param contractType * `order` - Order
 * * `modification` - Modification
 * * `cancel` - Cancel
   * @param endDate 
   * @param search Search fields: number, order__contractor__as_person__first_name, order__contractor__as_person__last_name, order__contractor__as_legalentity__name, order__contractor__as_legalentity__identification_number, order__contractor__as_person__identification_number
   * @param startDate 
   * @returns binary 
   * @throws ApiError
   */
  public static financialBorderoXlsxRetrieve(
agentId?: number,
agentType?: 'broker' | 'employee' | 'mobile' | 'website',
contractType?: 'cancel' | 'modification' | 'order',
endDate?: string,
search?: string,
startDate?: string,
): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/financial/bordero/xlsx/',
      query: {
        'agent_id': agentId,
        'agent_type': agentType,
        'contract_type': contractType,
        'end_date': endDate,
        'search': search,
        'start_date': startDate,
      },
    });
  }

}
